import { getValidCountryObject } from '@yembo/yemblocks-core/dist/_util';
import { getAddressFields } from 'src/util/googlePlaceMapping';
import { JobLocation } from '../Contact';

export type AddressFields = JobLocation & {
  name?: string;
  subdistrict?: string;
  district?: string;
  province?: string;
  prefecture?: string;
  postalCodeName?: string;
};

export const getPlaceFields = (countryShortName: string) => {
  const additionalFields = ['beds', 'baths', 'sqft']; //sqft is the api field, uses sq m also.
  const { postalCodeName, ...addressFields } = getAddressFields({}, countryShortName) as AddressFields;

  const fullAddressFields = [...Object.keys(addressFields), ...additionalFields];
  const indexOfAddressField2 = fullAddressFields.indexOf('addressLine2') || 2;
  fullAddressFields.splice(indexOfAddressField2 + 1, 0, 'gateCode');

  return { postalCodeName, fullAddressFields };
};

export const getCountryRegionCode = (countryLongName: string) => {
  const { regionCode = '' } = getValidCountryObject(countryLongName);
  return regionCode;
};

export const formatLabel = (value: string) => {
  const result = value.replace(/([A-Z1-9])/g, ' $1');
  return result.charAt(0).toUpperCase() + result.slice(1);
};
